import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../providers/auth_provider';
import AddTemplate from './add_template';
import DeleteTemplate from './delete_template';
import EditTemplate from './edit_template';

export default function EmailTemplates() {
    const { token, adminData } = useAuth();
    const [templates, setTemplates] = useState([]);
    const [limit, setLimit] = useState(10);
    const [searchTemplateName, setSearchTemplateName] = useState('');
    const [searchTemplateType, setSearchTemplateType] = useState('');
    const [searchTitle, setSearchTitle] = useState('');
    const [pagination, setPagination] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    // template_name, title, template_type, 
    const fetchTemplates = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/template`, {
                params: {
                    limit,
                    template_name: searchTemplateName,
                    title: searchTitle,
                    page: currentPage
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                }
            });
            setTemplates(res.data.templates);
            setPagination(res.data.pagination);
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [limit, searchTemplateName, searchTitle, searchTemplateType, currentPage]);

    return (
        <>
            <Helmet>
                <title>Manage Templates - Enervybe</title>
            </Helmet>
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">Templates List</h5>
                        {
                            <>
                                <button
                                    data-bs-target="#addNewTemplate"
                                    data-bs-toggle="offcanvas"
                                    className="btn btn-sm btn-label-primary text-nowrap add-new-role"
                                >
                                    <i className="ri-add-line me-2"></i> Add Template
                                </button>
                                <AddTemplate fetchTemplates={fetchTemplates} />
                            </>
                        }
                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div className="table-responsive">
                        <table className="datatables-ajax table table-bordered dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Template Name</th>
                                    <th>Subject</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td>
                                        <input
                                            type="search"
                                            className="form-control form-control-sm"
                                            placeholder="Search Template Name"
                                            value={searchTemplateName}
                                            onChange={(e) => setSearchTemplateName(e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="search"
                                            className="form-control form-control-sm"
                                            placeholder="Search Subject"
                                            value={searchTitle}
                                            onChange={(e) => setSearchTitle(e.target.value)}
                                        />
                                    </td>
                                    <td></td>
                                </tr>
                                {templates.map((template, index) => (
                                    <tr key={template.id}>
                                        <td>{index + 1}</td>
                                        <td>{template.template_name}</td>
                                        <td>{template.title}</td>
                                        <td className="text-center">
                                            {
                                                <button
                                                    onClick={() => setSelectedTemplate(template)}
                                                    data-bs-target="#editTemplate"
                                                    data-bs-toggle="offcanvas"
                                                    className="btn text-primary"
                                                >
                                                    <i className="ri-edit-line me-2"></i>
                                                </button>
                                            }
                                            {
                                                <button
                                                    onClick={() => setSelectedTemplate(template)}
                                                    data-bs-target="#deleteTemplate"
                                                    data-bs-toggle="modal"
                                                    className="btn text-danger"
                                                >
                                                    <i className="ri-delete-bin-line me-2"></i>
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <DeleteTemplate fetchTemplates={fetchTemplates} template={selectedTemplate} />
                        <EditTemplate fetchTemplates={fetchTemplates} template={selectedTemplate} />
                        <nav aria-label="Page navigation">
                            <ul className="pagination pagination-sm">
                                <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <a
                                        className="page-link waves-effect"
                                        href="#"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                                    </a>
                                </li>
                                {pagination?.pages &&
                                    pagination?.pages?.map((page) => (
                                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                            <a
                                                className="page-link waves-effect"
                                                href="#"
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </a>
                                        </li>
                                    ))}
                                <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                                    <a
                                        className="page-link waves-effect"
                                        href="#"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
}
